module.exports = __webpack_public_path__ + "static/media/sg-news-img3.1fadf5ec.png";